import { System } from '@ecs/System';
import { Position } from '@components/Position';
import { Health } from '@components/Health';
import { ShipClass } from '@components/ShipClass';
import { Renderable } from '@components/Renderable';
import { Effects } from '@/effects/Effects';

/** Ships at or below this share of their hull trail smoke */
export const SMOKE_THRESHOLD = 0.5;
/** Ships at or below this share also throw sparks */
export const SPARK_THRESHOLD = 0.34;

const SMOKE_EVERY = 4;  // frames
const SPARK_EVERY = 11; // frames

/** Badly damaged player ships trail smoke, and sparks when close to destruction. */
export class DamageSmokeSystem extends System {
  private frame = 0;

  update(_deltaTime: number): void {
    this.frame++;

    for (const ship of this.getEntitiesWithComponents(ShipClass, Health, Position)) {
      if (this.world.isPendingRemoval(ship)) continue;
      const health = ship.getComponent(Health)!;
      const ratio = health.max > 0 ? health.current / health.max : 1;
      if (ratio > SMOKE_THRESHOLD || health.current <= 0) continue;

      const position = ship.getComponent(Position)!;
      const size = ship.getComponent(Renderable)?.size ?? 10;
      const phase = this.frame + ship.id * 3;
      const x = position.x + (Math.random() - 0.5) * size * 0.8;
      const y = position.y + (Math.random() - 0.5) * size * 0.8;

      if (phase % SMOKE_EVERY === 0) {
        Effects.smoke(this.world, x, y, 1, '#9a9aaa');
      }
      if (ratio <= SPARK_THRESHOLD && phase % SPARK_EVERY === 0) {
        Effects.sparks(this.world, x, y, Math.random() * Math.PI * 2, 1.4, '#ffb347', 3, 2.5);
      }
    }
  }
}
